<template>
	<div class="cus-g-container cus-container">
		<van-image v-for="(item,index) in imgArr" :key="index" @load="load(item)" width="100%" height="auto" :lazy-load="true" class="cus-van-image" 
		:src="item.ossUrl" >
			<template v-slot:loading>
			    <van-loading type="spinner" size="20" />
			</template>
		</van-image> 
		<PinMyCom></PinMyCom> 
		
		<van-overlay :show="show" style="display: flex;justify-content: center;align-items: center;">
			<div class="cus-warp"> 
			    <van-loading type="spinner" size="24px" vertical color="rgba(182,165,130,1)" >加载中...</van-loading>
			</div>
		</van-overlay>
	</div>
</template>

<script>
	
	import PinMyCom from '@/components/PinMyCom.vue';
	
	export default {
		name: 'HomeView',
		data() {
			return {
				show: true,
				mainBody:'',
				imgArr:''
			}
		},
		components: {
			PinMyCom
		},
		
		created() { 
			this.mainBody = JSON.parse(localStorage.getItem("MAINBODY")); 
			 
		},
		mounted() { 
			console.log('HomeView mounted');  
			this.loadImgData();
			
		},

		methods: {
			  
			loadImgData(){ 
				let _params = {
					authToken: this.mainBody.authToken,
					type:'COMPANY_INFO'
				}  
				this.axios.get("/mainBody/listMainBodyImg_h5",{
					params: _params
				}).then((res)=>{ 
					if(2000 == res.code){ 
						this.imgArr = res.content;
					}else{
						this.$toast.fail(res.msg);
					}  
				}).catch((err)=>{
					console.error(err);
					this.$toast.fail('系统错误，请联系管理员');
				})
			},
			  
			load(_item){
				this.show = false;
			}	

		}
	}
</script>

<style scoped>
	.cus-container{
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		box-sizing: border-box;
		overflow: auto; 
	}
	
	.cus-van-image{
		box-sizing: border-box;
	}
	
</style>
